import React from "react";
import useDeviceType from "../../../custom-hooks/DeviceType";
import { goToIcon } from "../../../assets";
import EventEHRImageAvatar from "../../Atoms/image-avatar/EventEHRImageAvatar";
import EventEHRLinkTextWithIcon from "../../Atoms/link-text-with-icon/EventEHRLinkTextWithIcon";
import { TEXT_CONSTANTS } from "../../../utils/text-constants/textConstants";

interface PatientDetail {
  label: string;
  value: string;
}

interface EventEHRPatientProfileDetailCardWithEditProps {
  patientDetails: PatientDetail[];
  onEditClick?: () => void; // Callback function
  handleClickEvent?: () => void; // Callback function for health history link
  profileImage?: string; // URL of the profile image
}

const EventEHRPatientProfileDetailCardWithEdit = ({
  patientDetails,
  onEditClick,
  profileImage,
  handleClickEvent,
  // profileImage = dummyAvatar,
}: EventEHRPatientProfileDetailCardWithEditProps) => {
  const deviceType = useDeviceType();
  // ADJUSTED GRID MEANS MADE SCREEN RESPONSIVE
  const adjustedGrid =
    deviceType === "tablet" || deviceType === "small-tablet"
      ? "1fr 1fr 1fr"
      : deviceType === "mobile"
        ? "1fr"
        : "1fr 1fr 1fr 1fr 1fr";
  const adjustedWidth =
    deviceType === "tablet" ||
    deviceType === "small-tablet" ||
    deviceType === "mobile";

  const fullName =
    patientDetails.find((detail) => detail.label === "Full Name")?.value || "";

  return (
    <div
      className="flex justify-center items-start background-color-F1F1F1 border-radius-8px"
      style={{ padding: "20px 28px", gap: "60px" }}
    >
      <div
        style={{
          //   width: adjustedWidth ? "15%" : "10%",
          alignSelf: "center",
        }}
      >
        {deviceType != "mobile" && (
          <EventEHRImageAvatar
            labelText={fullName}
            image={profileImage}
            commonStyle={{
              width: "90px",
              height: "90px",
              border: "2px solid #BCBCBC",
              borderRadius: "8px",
            }}
          />
        )}
      </div>

      <div
        className="patient-details-card"
        style={{
          width: adjustedWidth ? "85%" : "90%",
          display: "grid",
          gridTemplateColumns: adjustedGrid,
          gap: "24px",
        }}
      >
        {patientDetails?.map((data, index) => (
          <div key={index} className="flex flex-col gap-2">
            <div className="font-size-14px font-weight-500 color-727272">
              {data?.label}
            </div>
            <div className="color-393939 font-weight-500">{data?.value}</div>
          </div>
        ))}

        {/* No explicit height: this is a grid item, so it already stretches to
            its row. `-webkit-fill-available` resolved against an ancestor in
            WebKit and inflated the whole card on iPad. */}
        <div
          className={` flex flex-col flex-1 gap-2  mb-2 justify-center ${deviceType === "mobile" ? "my-2 px-0" : ""}   `}
        >
          <EventEHRLinkTextWithIcon
            handleClickEvent={() => {
              handleClickEvent && handleClickEvent();
            }}
            linkText={TEXT_CONSTANTS?.OPEN_HEALTH_HISTORY}
            imageSrc={<img src={goToIcon} alt="goto icon" />}
            labelCustomStyle={{
              fontWeight: 500,
              fontSize: "16px",
              color: "#005596",
              cursor: "pointer",
            }}
          />
        </div>
      </div>
      <div>
        {" "}
        {/* EDIT ICON */}
        {/* <img
          className="cursor-pointer"
          src={editPencilBox}
          alt="edit-icon"
          onClick={() => {
            onEditClick && onEditClick();
            // setOpenEditProfileDialog(true);
          }}
        /> */}
      </div>
    </div>
  );
};

export default EventEHRPatientProfileDetailCardWithEdit;
